import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminUserService } from '@/modules/user/services/admin-user.service'
import { BillingInfoRequestModel } from '@/modules/billing-info/models/billing-info-request.model'

@vservice()
export class AdminUpdateUserBillingInfoUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminUserService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(userId: number, data: BillingInfoRequestModel) {
    return this.service.updateBillingInfo(userId, data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
